import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {some} from 'lodash'
import { Button } from 'primereact/button';

import { Checkbox  } from 'primereact/checkbox';

// eslint-disable-next-line import/no-cycle
import CustomTree from '@components/CustomTree'

import { SECTION_HOME_ID } from '@constants/general'

import './style.scss'

class RowTree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCheked: true,
      isCollapsed: true
    };
  }


  componentDidMount () {
    this.setState({
      isCheked: this.validateCheck(),
      isCollapsed: this.validateIsCollpase()
    })

  }
  componentDidUpdate (prevProps) {
    if (prevProps.sectionsCollapse !== this.props.sectionsCollapse) {
      this.setState({isCollapsed: this.validateIsCollpase()})
    }
  }

  arrayContainsArray =  (array1, array2) => {
    let isInclude = false
    array2.map((item) => {
      if (array1.includes(item)) isInclude = true
    })
   return isInclude
  }


  validateCheck = () => {
    const { sectionsLocked, data, parentItems } = this.props
    // Convertir parentItems en un array
    // Validar si en parentItems existe alguno de sectionsLocked
    // Si: Entonces ischecked: false
    // No: Validamos si en sectionsLocked existeel data.key
      // Si: Entonces ischecked: false
      // NO: Entonces ischecked: true
    const parentsKey = parentItems.split('|').map(item=> parseInt(item, 10))
    const found = this.arrayContainsArray(sectionsLocked, parentsKey)
    if (found) return false
    if (sectionsLocked.includes(data.key)) return false
    return true
  }

  validateIsCollpase = () => {
    const { sectionsCollapse, data } = this.props
    const isCollapse = sectionsCollapse.find(item => item === data.key)
    if (isCollapse) return true
    return false
  }

  onChangeSelected = async (e, data) => {
    const { validateSectionsLocked, sectionsLocked } = this.props
    let newSectionsLocked = sectionsLocked || []
    if (e.value === SECTION_HOME_ID) return true
    if (e.checked) {
      newSectionsLocked = sectionsLocked.filter(item => item !== e.value)
    } else {
      newSectionsLocked.push(e.value)
    }

    await validateSectionsLocked(newSectionsLocked)
    // this.setState({isCheked: this.validateCheck()})

  }

  onchangeCollapse = () => {
    // const { isCollapsed } = this.state
    // this.setState({isCollapsed: !isCollapsed})
    const { data, onSectionsCollapse } = this.props
    onSectionsCollapse(data)
  }

  render() {
    const { data, sectionsLocked, validateSectionsLocked, parentItems, sectionsCollapse, onSectionsCollapse } = this.props;
    const { isCheked, isCollapsed } = this.state;

    const hasChildrens = data?.children && data?.children.length

    return (
      <li key={data.key} className="p-treenode">
        <div className={`p-treenode-content p-highlight ${!hasChildrens ? 'padding-tb-tree'  : ''}`}>
          { hasChildrens && (
            <Button
              className="p-button-text p-button-secondary p-mr-2"
              icon={`pi ${isCollapsed ? 'pi-chevron-down' : ' pi-chevron-right'}`}
              onClick={() => this.onchangeCollapse()}
            />
          )}
          <Checkbox
            name="sectionsLocked"
            className={`p-mr-2 ${!hasChildrens ? 'margin-left-tree'  : ''}`}
            value={data.key}
            // className='p-mr-2'
            onChange={(e) => this.onChangeSelected(e, data)}
            checked={isCheked}
          />
          <span className='p-treenode-label'> { data.label} </span>
          {/* <span className='p-treenode-label'>  {data.key} - {parentItems} </span> */}
        </div>
        { isCollapsed && hasChildrens && (
          <CustomTree
            value={data.children}
            sectionsLocked={sectionsLocked}
            validateSectionsLocked={validateSectionsLocked}
            parentItems={parentItems ? `${parentItems}|${data.key}` : `${data.key}`}
            sectionsCollapse={sectionsCollapse}
            onSectionsCollapse={onSectionsCollapse}
          />
        )}
      </li>
    )
  }
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(RowTree);
